module.exports = __webpack_public_path__ + "static/videoES_2-190678f7e46b4b4c62552bbf4e420bab.mp4";